import React from 'react';
import heroImage from '../assets/hero.jpg';

const Hero = () => (
  <section 
    className="h-screen bg-center bg-cover sm:bg-[center_bottom_-85px] flex items-center justify-center text-center text-white"
    style={{ backgroundImage: `url(${heroImage})` }}
  >
    <div className="bg-black bg-opacity-50 p-2 mt-[20px] sm:mt-0 sm:p-4 mb-10 sm:mt-48 rounded">
      <h1 
        className="text-center uppercase mt-0 mb-1 font-medium transition-colors duration-200 ease-in-out 
                   text-[16px] sm:text-[40px] 
                   tracking-[2px] sm:tracking-[4px]"
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        Pearls for the Pearl
      </h1>
      <p 
        className="text-center uppercase mt-0 mb-3 font-medium transition-colors duration-200 ease-in-out 
                   text-[7px] sm:text-[12px] 
                   tracking-[1px] sm:tracking-[2.4px]"
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        Timeless elegance crafted with care
      </p>
      <a 
        href="/shop" 
        className="bg-white text-black inline-block px-4 py-2 sm:px-6 sm:py-3 uppercase tracking-wider 
                   hover:bg-gray-200 transition-colors duration-200 ease-in-out
                   text-[12px] sm:text-[14px]"
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      >
        Shop Now
      </a>
    </div>
  </section>
);

export default Hero;
